import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { VAlign } from '@algbra/ui/enums/align'
import dayjs from 'dayjs'
import { graphql, useStaticQuery } from 'gatsby'
import { filter, map, sort, take } from 'rambdax'
import { ReactNode } from 'react'
import { EventEntity } from '../../types/event'
import MeetupItem from './MeetupItem'
import MeetupItemFeatured from './MeetupItemFeatured'
import styles from './MeetupList.module.scss'

export type ZoneMeetupListProps = {
  __typename: 'StrapiGQL_ComponentZonesMeetupList'
  title: ReactNode
  kind: 'past' | 'future'
  id: number
  limit: number
}

export const QUERY_EVENTS = graphql`
  query EventsQuery {
    strapiGQL {
      events(publicationState: LIVE, sort: "id:desc", limit: 50) {
        id
        title
        slug
        summary
        date
        location
        link
        type
        isFeatured
        image {
          id
          url
          ext
          resolved {
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                formats: WEBP
                webpOptions: { quality: 100 }
                placeholder: DOMINANT_COLOR
              )
            }
          }
        }
        backgroundImage {
          id
          url
          ext
          resolved {
            publicURL
          }
        }
        logoImage{
          id
          url
          ext
          resolved {
            publicURL
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                formats: WEBP
                height: 100
                webpOptions: { quality: 100 }
                placeholder: DOMINANT_COLOR
              )
            }
          }
        }
        theme
        youtube_code
      }
    }
  }
`

export default function ZoneMeetupList(props: ZoneMeetupListProps) {
  const { title, limit = 3, kind } = props
  const {
    strapiGQL: { events },
  } = useStaticQuery(QUERY_EVENTS)
  const eventSortFunc = (x, y) => {
    if (kind === 'future') {
      return x.id > y.id ? 1 : -1
    } else {
      return x.id > y.id ? -1 : 1
    }
  }
  const filteredEvents = take(
    limit,
    filter(event => {
      const today = new Date()
      if (kind === 'future') {
        return dayjs(event.date).isAfter(today)
      } else {
        return dayjs(event.date).isBefore(today)
      }
    }, sort(eventSortFunc, events) as EventEntity[])
  )
  return (
    <Whitespace type="md">
      <Container>
        <Heading level={2} type="lg" className={styles.title}>
          {title}
        </Heading>
        <Row vAlign={VAlign.STRETCH}>
          {map(
            event => (
              <Column size={12} sm={6} lg={4} key={event.id}>
                {event.isFeatured ? <MeetupItemFeatured event={event} /> : <MeetupItem event={event} />}
              </Column>
            ),
            filteredEvents || []
          )}
        </Row>
      </Container>
    </Whitespace>
  )
}
